import z from "zod";

export const BeneficiarioSchema = z.object({
  tipoBeneficiario: z.string().min(1, "Es requerido seleccionar un tipo"),
  rut: z
    .string()
    .min(2, "RUT demasiado corto")
    .max(12, "RUT demasiado largo")
    .regex(/^\d{1,2}(\.\d{3}){0,2}-[0-9K]$/i, "Formato de RUT inválido"),
  nombre: z.string().min(1, "Es requerido el nombre"),
  apellidoPaterno: z.string().min(1, "Es requerido ingresar un apellido"),
  apellidoMaterno: z.string().min(1, "Es requerido ingresar un apellido"),
  fechaNacimiento: z
    .string()
    .min(1, "Es requerido ingresar una fecha de nacimiento"),
  parentesco: z
    .union([z.string(), z.number()])
    .refine((val) => val !== "" && val !== undefined, {
      message: "Debe seleccionar un parentesco",
    }),
  email: z
    .string()
    .min(1, "Es requerido ingresar un email")
    .email("Email inválido"),
  sexo: z
    .union([z.string(), z.number()])
    .refine((val) => val !== "" && val !== undefined, {
      message: "Es requerido seleccionar sexo",
    }),
  region: z
    .union([z.string(), z.number()])
    .refine((val) => val !== "" && val !== undefined, {
      message: "Es requerido seleccionar región",
    }),
  ciudad: z
    .union([z.string(), z.number()])
    .refine((val) => val !== "" && val !== undefined, {
      message: "Es requerido seleccionar una ciudad",
    }),
  comuna: z
    .union([z.string(), z.number()])
    .refine((val) => val !== "" && val !== undefined, {
      message: "Es requerido seleccionar la comuna",
    }),
  direccion: z.string().min(1, "Es requerido ingresar una dirección"),
  casaDepto: z.string().min(1, "Es requerido ingresar una nro de casa"),
  celular: z.string().min(1, "Es requerido ingresar un celular"),
  accion: z.string().min(1, "Es requerido la Acción"),
  porcentaje: z.union([z.string(), z.number()]).refine(
    (val) => {
      const num = Number(val);
      return !isNaN(num) && num > 0 && num <= 100;
    },
    {
      message: "El porcentaje debe ser entre 1 y 100",
    }
  ),
});

export type BeneficiarioFormZod = z.infer<typeof BeneficiarioSchema>;
